module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/pets/fitsize//snow_4_2.png?v=a6ac3e0d";